import React, { useState } from 'react';

import styled from 'styled-components';

import { Layout, Menu, Breadcrumb } from 'antd';
import {
  DesktopOutlined,
  PieChartOutlined,
  TeamOutlined,
  UserOutlined,
  ToolOutlined,
} from '@ant-design/icons';

import VisualizationDecision from './components/VisualizationDecision';

enum MenuItemKey {
    Import,                 // 0: 存储
    Retrieve,               // 1: 检索
    TotalAmount,            // 2: 总额
    Income,                 // 3: 收入
    Outgo,                  // 4: 支出
    Account,                // 5: 账号
    Password,               // 6: 密码
    VisualizationDecision,  // 7: 图表决策
    Baidu,                  // 8: 百度，测试
};

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

const SiteLayout: React.FunctionComponent = (): JSX.Element => {
    const [collapsed, setCollapsed] = useState<boolean>(false);

    const [menuItemHide, setMenuItemHide] = useState<boolean[]>([
        true,  // Import,                 => 0: 存储
        true,  // Retrieve,               => 1: 检索
        true,  // TotalAmount,            => 2: 总额
        true,  // Income,                 => 3: 收入
        true,  // Outgo,                  => 4: 支出
        true,  // Account,                => 5: 账号
        true,  // Password,               => 6: 密码
        true,  // VisualizationDecision,  => 7: 图表决策
        true,  // Baidu,                  => 8: 百度，测试
    ]);

    const onCollapse = (c: boolean) => {
        setCollapsed(c);
    }

    const onMenuItemClick = (e: any) => {
        setMenuItemHide(prev => {
            prev = prev.map((item, key) => Number(e.key) === Number(key) ? false : item || true);
            return prev;
        });
    };

    return (
        <DefaultLayout>
            <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
                <Logo />
                <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline" onClick={onMenuItemClick}>
                    <Menu.Item key={MenuItemKey.Import} icon={<PieChartOutlined />}>
                        存储
                    </Menu.Item>
                    <Menu.Item key={MenuItemKey.Retrieve} icon={<DesktopOutlined />}>
                        检索
                    </Menu.Item>
                    <SubMenu key="sub1" icon={<UserOutlined />} title="资产">
                        <Menu.Item key={MenuItemKey.TotalAmount}>总额</Menu.Item>
                        <Menu.Item key={MenuItemKey.Income}>收入</Menu.Item>
                        <Menu.Item key={MenuItemKey.Outgo}>支出</Menu.Item>
                    </SubMenu>
                    <SubMenu key="sub2" icon={<TeamOutlined />} title="我的">
                        <Menu.Item key={MenuItemKey.Account}>账号</Menu.Item>
                        <Menu.Item key={MenuItemKey.Password}>密码</Menu.Item>
                    </SubMenu>
                    <SubMenu key="sub3" icon={<ToolOutlined />} title="工具">
                        <Menu.Item key={MenuItemKey.VisualizationDecision}>图表决策</Menu.Item>
                        <Menu.Item key={MenuItemKey.Baidu}><a href="https://www.baidu.com" target="_blank" rel="noopener noreferrer ~">百度</a></Menu.Item>
                    </SubMenu>
                </Menu>
            </Sider>
            <Layout>
                <SiteHeader />
                <Content style={{ margin: '0 16px' }}>
                    <Breadcrumb style={{ margin: '16px 0' }}>
                        <Breadcrumb.Item>User</Breadcrumb.Item>
                        <Breadcrumb.Item>Bill</Breadcrumb.Item>
                        <Breadcrumb.Item>Apple</Breadcrumb.Item>
                    </Breadcrumb>
                    <div style={{ padding: 24, minHeight: 360, background: '#fff' }}>
                        {!menuItemHide[MenuItemKey.VisualizationDecision] && <VisualizationDecision />}
                    </div>
                </Content>
                <Footer style={{ textAlign: 'center' }}>Alaska ©2020 Created by Damon HKC</Footer>
            </Layout>
        </DefaultLayout>
    );
};

export default SiteLayout;

const DefaultLayout = styled(Layout)`
    min-height: 100vh;
`;

const Logo = styled.div`
    height: 32px;
    background: rgba(255, 255, 255, 0.2);
    margin: 16px;
`;

const SiteHeader = styled(Header)`
    background: #fff;
    padding: 0;
`;

